module.exports = __webpack_public_path__ + "static/media/mz.1c91e7d5.svg";